import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useLanguages } from "@/hooks/useLanguages";

const STORAGE_KEY = "mori_language";

const FALLBACK_LANGUAGES = [
  { code: "en", name: "English",    flag_emoji: "🇬🇧" },
  { code: "sk", name: "Slovenčina", flag_emoji: "🇸🇰" },
];

export function PublicShell({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  const { languages, isLoading } = useLanguages("active");

  const displayLanguages = !isLoading && languages.length > 0
    ? languages
    : FALLBACK_LANGUAGES;

  function handleLangChange(code: string) {
    i18n.changeLanguage(code);
    localStorage.setItem(STORAGE_KEY, code);
  }

  const current = i18n.resolvedLanguage ?? i18n.language;

  return (
    <div className="h-[100dvh] bg-muted/50 flex justify-center overflow-hidden">
      <div className="w-full max-w-[430px] bg-background flex flex-col h-[100dvh] overflow-y-auto">
        <div className="sticky top-0 z-10 flex justify-end px-4 py-2 bg-background/80 backdrop-blur-sm border-b border-border/40">
          <select
            value={current}
            onChange={e => handleLangChange(e.target.value)}
            disabled={isLoading}
            className="text-sm bg-transparent border-none outline-none cursor-pointer text-muted-foreground disabled:opacity-50"
            aria-label="Language"
          >
            {displayLanguages.map(l => (
              <option key={l.code} value={l.code}>
                {l.flag_emoji} {l.name}
              </option>
            ))}
          </select>
        </div>
        {children}
      </div>
    </div>
  );
}

